import { TicketReportSpace } from '../interfaces/models/ticket.interfaces'

export const SPACE_TRANSLATION_KEY: Record<TicketReportSpace, string> = {
  apartment: 'ticketView.form.space.apartment',
  building: 'ticketView.form.space.building',
  surroundings: 'ticketView.form.space.surroundings',
  'common-areas': 'ticketView.form.space.commonAreas',
  other: 'ticketView.form.space.other',
}
